"use strict";
var BoundNodeCallbackObservable_1 = require('./BoundNodeCallbackObservable');
exports.bindNodeCallback = BoundNodeCallbackObservable_1.BoundNodeCallbackObservable.create;
//# sourceMappingURL=bindNodeCallback.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/rxjs/observable/bindNodeCallback.js
// module id = ./node_modules/rxjs/observable/bindNodeCallback.js
// module chunks = 0